import {AccreditationStatus as AccreditationStatuses} from 'src/openapi/admin/models/AccreditationStatus';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const ACCREDITATION_STATUS_DICTIONARY: DictionaryItem[] = [
    {code: AccreditationStatuses.EMPTY, description: ''},
    {code: AccreditationStatuses.ACCREDITED, description: 'Accredited'},
    {code: AccreditationStatuses.NOT_ACCREDITED, description: 'Confirmed No'},
];
